import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=f43070cc&scoped=true&lang=pug&"
import script from "./footer.vue?vue&type=script&lang=js&"
export * from "./footer.vue?vue&type=script&lang=js&"
import style0 from "./footer.vue?vue&type=style&index=0&id=f43070cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43070cc",
  null
  
)

/* custom blocks */
import block0 from "~/lang/footer?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230608160537%2Fcomponents%2Fsite%2Ffooter.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports